import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';

import DeadReportTab from './DeadReportTab';
import NoticeReceivedTab from './NoticeReceivedTab';
import DocusignReceivedTab from './DocusignReceivedTab';
import DocusignReviewTab from './docusignReviewTab/DocusignReviewTab';
import FwdContractsTab, { TabListEntryFwdContracts } from './fwdContractsTab/FwdContractsTab';

import NoticeMissingTab from './NoticeMissingTab';
import SendTab from './SendTab';
import BillReviseTab from './BillReviseTab';
import FinalReviewTab from './FinalReviewTab';
import CallbackTab from './CallbackTab';

export const EntryListTodo = {
  noDefault: true,
  tabs: [
    { 
      label: 'Dead Report',
      children: <DeadReportTab />,
    },
    { 
      label: 'Notice Received',
      children: <NoticeReceivedTab />,
      icon: 'tabler:message-down'
    },
    {
      label: 'Notice Missing',
      children: <NoticeMissingTab />,
      icon: 'subway:missing',
      color: 'info',
    },
    {
      label: 'Send',
      children: <SendTab />,
      icon: 'material-symbols:mail-outline',
      color: 'warning',
    },
    {
      label: 'Docusign Received',
      children: <DocusignReceivedTab />,
      icon: 'uil:file-download-alt',
    },
    {
      label: 'Docusign Review',
      children: <DocusignReviewTab />,
      icon: 'material-symbols:attach-file',
    },
    { 
      label: 'Callback',
      children: <CallbackTab />,
      icon: 'mdi:phone'
    },
    {
      label: 'Final Review',
      children: <FinalReviewTab />,
      icon: 'material-symbols:verified'
    },
    {
      label: 'Fwd Contracts',
      children: <FwdContractsTab />,
      nested: TabListEntryFwdContracts
    },
    {
      label: 'Bill Revise',
      children: <BillReviseTab />,
      icon: 'la:file-invoice-dollar',
      color: 'info',
    },
  ],
};

export default function EntryTab() {
  return (
    <CasRouterTabs
      asButtons
      baseUrl="/endorsements/claimtracking/entry"
      tabList={EntryListTodo.tabs}
    />
  );
}
